<template>
    <div class="qty">
        <div class="qty__btn" @click="minus()"><i class="bi bi-dash"></i></div>
        <div class="qty__num">{{ qty }}</div>
        <div class="qty__btn" @click="add()"><i class="bi bi-plus"></i></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            qty: 1,
        };
    },
    methods: {
        add() {
            this.qty++;
        },
        minus() {
            if (this.qty > 1) {
                this.qty--;
            }
        },
    },
};
</script>
